import CommonSettings from './CommonSettings'

export default function ColumnSettings({ block, onUpdate }) {
  const { settings } = block

  const updateColumnCount = (count) => {
    const currentCols = settings.columns || []
    const newCols = Array.from({ length: count }, (_, i) => {
      if (currentCols[i]) {
        return currentCols[i]
      }
      return {
        id: `col-${i}`,
        content: '',
        blocks: []
      }
    })
    onUpdate({ columnCount: count, columns: newCols })
  }

  const updateColumnContent = (index, content) => {
    const newColumns = [...(settings.columns || [])]
    if (newColumns[index]) {
      newColumns[index] = { ...newColumns[index], content }
      onUpdate({ columns: newColumns })
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <h4 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>Column Settings</h4>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Number of Columns
        </label>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {[2, 3, 4].map(count => (
            <button
              key={count}
              onClick={() => updateColumnCount(count)}
              style={{
                flex: 1,
                padding: '0.5rem',
                border: settings.columnCount === count ? '2px solid var(--color-primary)' : '1px solid #e5e7eb',
                borderRadius: '6px',
                background: settings.columnCount === count ? 'rgba(99, 102, 241, 0.08)' : '#fff',
                color: settings.columnCount === count ? 'var(--color-primary)' : '#64748b',
                fontWeight: settings.columnCount === count ? '600' : '400',
                fontSize: '0.85rem',
                cursor: 'pointer'
              }}
            >
              {count}
            </button>
          ))}
        </div>
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Gap: {settings.gap || '2%'}
        </label>
        <input
          type="range"
          min="0"
          max="10"
          step="1"
          value={parseInt(settings.gap) || 2}
          onChange={(e) => onUpdate({ gap: `${e.target.value}%` })}
          style={{ width: '100%', cursor: 'pointer' }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.7rem', color: '#94a3b8', marginTop: '0.25rem' }}>
          <span>0%</span>
          <span>5%</span>
          <span>10%</span>
        </div>
      </div>

      <h4 style={{ margin: '0.5rem 0', fontSize: '0.9rem', fontWeight: '600' }}>Column Content</h4>
      <p style={{ margin: 0, fontSize: '0.75rem', color: '#94a3b8' }}>
        Drag blocks from the toolbox into each column, or add text content below.
      </p>

      {(settings.columns || []).map((col, idx) => (
        <div key={idx} style={{
          padding: '0.75rem',
          background: 'var(--color-bg-secondary)',
          borderRadius: 'var(--radius-md)',
          marginBottom: '0.25rem'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
            <label style={{ fontSize: '0.8rem', fontWeight: '500' }}>
              Column {idx + 1}
            </label>
            <span style={{ fontSize: '0.7rem', color: '#94a3b8' }}>
              {col.blocks?.length || 0} block{(col.blocks?.length || 0) !== 1 ? 's' : ''}
            </span>
          </div>
          <textarea
            value={col.content || ''}
            onChange={(e) => updateColumnContent(idx, e.target.value)}
            placeholder="Optional text content..."
            rows={2}
            style={{
              width: '100%',
              fontSize: '0.85rem',
              padding: '0.5rem',
              fontFamily: 'inherit',
              resize: 'vertical'
            }}
          />
        </div>
      ))}

      <CommonSettings settings={settings} onUpdate={onUpdate} />
    </div>
  )
}
